import React from 'react';
import { ProductTile } from '../product-tile';
import { DoorRecommendation } from '../../../../entities-generated/common/door-recommendation';
import { IStormDoorHandleModel } from '../../../../entities-generated/models/storm-door/storm-door-handle-model';

interface IStormHandleTileProps {
  idPrefix: string;
  handle: IStormDoorHandleModel;
  onSelected: (handle: IStormDoorHandleModel) => void;
  recommendation: DoorRecommendation;
}

export const StormHandleTile: React.FunctionComponent<IStormHandleTileProps> = (props) => {
  const { handle } = props;

  return (
    <ProductTile
      id={handle.id}
      idPrefix={props.idPrefix}
      imageUrls={[handle.imageUrl]}
      brand={handle.brand}
      description={handle.description}
      textures={handle.textureVariants}
      price={0}
      onProductSelected={() => props.onSelected(handle)}
      recommendation={props.recommendation}
    />
  );
};
